import debounce from "debounce";

class HeaderHeight {
	headerMainEl;
	headerSubEl;

	/**
	 * Instantiate class.
	 */
	constructor() {
		this.headerMainEl = document.querySelector( '.elementor-location-header .whippet-header--main' );
		this.headerSubEl = document.querySelector( '.elementor-location-header .whippet-header--sub' );

		if( !this.headerMainEl || !this.headerSubEl ) {
			return;
		}

		this.registerResizeEvents();
		this.setVariables();
	}

	/**
	 * Watch for resize and update scroll padding.
	 */
	registerResizeEvents() {
		window.addEventListener( 'resize', debounce( () => this.setVariables(), 100 ), { passive: true } );
	}

	/**
	 * Set scroll padding value.
	 */
	setVariables() {
		document.documentElement.style.setProperty( '--whippet-header-height--main', this.headerMainEl.getBoundingClientRect().height + 'px' );
		document.documentElement.style.setProperty( '--whippet-header-height--sub', this.headerSubEl.getBoundingClientRect().height + 'px' );
	}
}

new HeaderHeight();
